import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Loader from 'react-loader-spinner'
import ErrorBoundary from '../errorBoundary';
import {navigate} from 'hookrouter';

import {
  selectLoginData,
 } from '../login/loginSlice'

import {
 selectOrdersData,
 updateMRN,
 updateAccession,
 getDataAsync,
 clearOrdersData
} from './ordersSlice';
import styles from './orders.module.css';
import DisplayTable from './displayTable';



export function Orders() {

  const getData = ((requestType) => {
    console.log('requestType = ' +requestType);
    dispatch(getDataAsync(searchMRN,searchAccession,jwt,requestType))
  })

  let { jwt } = useSelector(selectLoginData);
  let {searchMRN, searchAccession,  Processing }  = useSelector(selectOrdersData);
  const dispatch = useDispatch();
  let requestType = '';
  return (
    <div>
    <div>
    <div>
       <button
          className={styles.loginBtn}
          aria-label="sweepBtn"
          onClick={() => {navigate("/sweeps")}}
        >
        sweep
        </button>
        <button
          className={styles.loginBtn}
          aria-label="loadingMonitorBtn"
          onClick={() => {navigate("/LoadingMonitor")}}
        >
        Loading Monitor
        </button>
       
        <button
          className={styles.loginBtn}
          aria-label="sweeBtn"
          onClick={() => {navigate("/accChecker")}}
        >
        acc Checker
        </button>
        </div>
        <div className={styles.row}>
        <label  className={styles.descriptors}
          htmlFor="usesearchMRN">MRN
        </label>
    
        <input
          id="usesearchMRN"
          className={styles.input}
          aria-label="SearchMRN"
          value={searchMRN}
          onChange={e => dispatch(updateMRN(e.target.value))}
        >
        </input>
        <label  className={styles.descriptors}
          htmlFor="usersearchAccession">
            Accession #
        </label>
        <div className={styles.row}>
        <input
          id="usersearchAccession"
          className={styles.input}
          aria-label="Accession#"
          type="text"
          value={searchAccession}
          onChange={e => dispatch(updateAccession(e.target.value))}
        >
        </input>
        <button
          className={styles.loginBtn}
          aria-label="clearhDataBtn"
          onClick={() => dispatch(clearOrdersData([]))}
        >
      Clear
        </button>

        </div>
        </div>
        <button
          className={styles.loginBtn}
          aria-label="fetchDataBtn"
          onClick={() => {getData('orders')}}
        >
       Search Orders
        </button>
        <button
          className={styles.loginBtn}
          aria-label="fetchDataBtn"
          onClick={() => {requestType='results'; dispatch(getDataAsync(searchMRN,searchAccession,jwt,requestType))}}
        >
       Search Results
        </button>

        <button
          className={styles.loginBtn}
          aria-label="fetchDataBtn"
          onClick={() => {requestType='priorResults'; dispatch(getDataAsync(searchMRN,searchAccession,jwt,requestType))}}
        >
       Search Prior Results
        </button>


        <button
          className={styles.loginBtn}
          aria-label="fetchDataBtn"
          onClick={() => {getData('ph_prefetch')}}
        >
       Search Prefetch
        </button>
     
        <button
          className={styles.loginBtn}
          aria-label="fetchDataBtn"
          onClick={() => {getData('ph_orm')}}
        >
       Search PACSHealth ORM
        </button>
        <button
          className={styles.loginBtn}
          aria-label="fetchDataBtn"
          onClick={() => {getData('m7Study')}}
        >
       Search Mach7 Studies
        </button>

      </div>
      
      <div className={styles.rowWhite}>
      {(Processing) ? <Loader 
         type="Puff"
         color="#00BFFF"
         height={100}
         width={100}
         //timeout={3000} //3 secs
      /> :   <ErrorBoundary>
             <DisplayTable /> 
             </ErrorBoundary>
      }
       </div>
     </div>
  );
}
